export default __webpack_public_path__ + "static/media/deeperInsights.521512df.svg";